export default __webpack_public_path__ + "static/1989-10-26_timbre_SMT.pdf";